import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import AddToCalendar from 'react-add-to-calendar';
import moment from 'moment-timezone';
import concatDateTime from '../utils/concatDateTime';
import InitialBookingDisclaimer from '../components/InitialBookingDisclaimer';

import { ReactComponent as Checkmark } from '../static/img/checkmark.svg';
import { ReactComponent as ArrowRight } from '../static/img/arrow-right.svg';
import { ReactComponent as Padlock } from '../static/img/padlock.svg';

import './ConsultantConfirm.sass';

export default () => {
  const {
    state: {
      consultant,
      hospital,
      slotDate,
      slotTime,
      slotDuration,
      specialty,
      gpReferral,
      consultationFor,
      mandatoryPayment,
      optionalPayment,
      paymentToken,
      paymentStatus,
      cardholderDetails,
      parentURL,
      formValues: { insurer, payment },
    },
  } = useLocation();

  useEffect(() => {
    window.parent.postMessage(
      {
        event_id: 'dataLayer',
        data: {
          event: 'consultantBookingConfirmation',
          consultant: {
            consultation_time: `${slotDate}, ${slotTime}`,
            form_type: 'Online Booking',
            id: consultant.gmcCode,
            location: hospital.hospitalName,
            specialty: specialty,
          },
          has_referral_letter: gpReferral ? 1 : 0,
          consultation_for: consultationFor,
          payment_method: payment,
          journey_type: mandatoryPayment
            ? 'mandatory'
            : optionalPayment
              ? 'optional'
              : 'not in trial',
          cardholder_details: cardholderDetails ? cardholderDetails : 'N/A',
          payment_status: paymentStatus,
          pmi_name: insurer,
        },
      },
      parentURL,
    );
  }, [
    consultant.gmcCode,
    gpReferral,
    hospital.hospitalName,
    slotDate,
    slotTime,
    specialty,
    consultationFor,
    payment,
    mandatoryPayment,
    optionalPayment,
    cardholderDetails,
    insurer,
    paymentStatus,
    parentURL,
  ]);

  const mStart = concatDateTime(moment(slotDate, 'YYYY-MM-DD'), moment(slotTime, 'HH:mm'));

  useEffect(() => {
    if ('parentIFrame' in window) {
      window.parentIFrame.scrollToOffset(0, 0);
    }
  }, []);

  const mEnd = mStart.clone().add(slotDuration, 'minutes');

  const paymentNotice = paymentToken && (mandatoryPayment || optionalPayment) && (
    <div className="payment-notice">
      <div>
        <Padlock />
      </div>
      <p>
        Your payment details have been successfully authorised and will be securely stored for when
        payment is due.
      </p>
    </div>
  );

  return (
    <>
      <InitialBookingDisclaimer />
      <div className="m--consultant-confirm">
        <div className="pattern" />
        <div className="header__wrapper mb-40">
          <div className="header">
            <h2 className="h2">Book consultant</h2>
          </div>
        </div>
        <div className="booked">
          <span className="icon__wrapper">
            <Checkmark />
          </span>{' '}
          Booked
        </div>
        <span className="divider" />
        <div className="h2 mt-30 mb-10">Consultation</div>
        <div className="details__wrapper">
          <div className="details-grid" role="group" aria-label="appointment-details">
            <div className="details-grid__label">Time</div>
            <div className="details-grid__value">
              {slotTime} {mStart.format('Do MMMM YYYY')}
            </div>
            <div className="details-grid__label">Duration</div>
            <div className="details-grid__value">{slotDuration} minutes</div>
            <div className="details-grid__label">Consultant</div>
            <div className="details-grid__value">{consultant.name}</div>
            <div className="details-grid__label">Location</div>
            <div className="details-grid__value">{hospital.hospitalName}</div>
          </div>
          <div className="col-2">
            <div>
              <p>
                We’ll contact you if necessary to collect any additional information. If you need to
                cancel or change your appointment, please contact us as soon as possible on{' '}
                <a href="tel:03001231903">0300 123 1903</a>.
              </p>
              <div className="add-to-calendar-link__wrapper">
                <AddToCalendar
                  event={{
                    title: `Consultancy from ${consultant.name}`,
                    location: hospital.hospitalName,
                    description: '',
                    startTime: mStart.format(),
                    endTime: mEnd.format(),
                  }}
                />
                <span className="icon__wrapper">
                  <ArrowRight />
                </span>
              </div>
            </div>
            {paymentNotice}
          </div>
        </div>
        <span className="divider" />
      </div>
    </>
  );
};
